import React from "react";
import { SocialMedia } from "../../Components/SocialMedia/SocialMedia";
import { ContactButton } from "../../Components/Button/ContactButton";
// import { Button } from "../../Components/Button/Button";
// import { socialMediaLinks } from "../../portfolio";
import { darkTheme } from "./../../theme";
// import { NavLink } from "react-router-dom";
import styles from "./Contact.module.css";
import { Heading } from "./../CategoryHeading/Heading";
import { useForm } from "react-hook-form";
import emailjs from "emailjs-com";
import { toast } from "react-toastify";
import {
    FormControl,
    InputLabel,
    Input,
    TextareaAutosize,
} from "@material-ui/core";
// import { Button as ContactButton } from "antd";

export const Contact = () => {
    const theme = darkTheme;
    const { reset } = useForm();

    const [name, setName] = React.useState("");
    const [email, setEmail] = React.useState("");
    const [subject, setSubject] = React.useState("");

    // Function that displays a success toast on bottom right of the page when form submission is successful
    const toastifySuccess = () => {
        toast("Form sent!", {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            className: "submit-feedback success",
            toastId: "notifyToast",
        });
    };

    // Function called on submit that uses emailjs to send email of valid contact form
    const handleSubmit = async (data) => {
        // Destrcture data object
        console.log("Hii");
        const { name, email, subject } = data;

        if (name === "" || email === "" || subject === "") {
            alert("All Fields are Mandatory");
        } else {
            try {
                const templateParams = {
                    name,
                    email,
                    subject,
                };
                await emailjs.send(
                    process.env.REACT_APP_SERVICE_ID,
                    process.env.REACT_APP_TEMPLATE_ID,
                    templateParams,
                    process.env.REACT_APP_USER_ID,
                );
                reset();
                toastifySuccess();
                alert("Your Message is sent succesfully");
                setName("");
                setEmail("");
                setSubject("");
            } catch (e) {
                console.log("Error", e);
            }
        }

        console.log(name, email, subject);
        console.log("Hiiii Suman");
    };

    return (
        <div className={styles.contact_main}>
            <div className={styles.contact_heading_text_div}>
                {/* <Heading title="𝐏𝐫𝐨𝐣𝐞𝐜𝐭𝐬" /> */}
                <Heading title="𝐂𝐨𝐧𝐭𝐚𝐜𝐭𝐬" />
                <p className={`${styles.contact_header_detail_text}`}>
                    Problem solver and aspiring Full-Stack Web Developer. Want
                    to start career in a reputed software company where everyday
                    there will be a learning experience.
                </p>
                <SocialMedia theme={theme} />
                {/* <NavLink
                    to="/Documents/Suman_CV.pdf"
                    target="_blank"
                    download
                    style={{ textDecoration: "none", border: "1px solid red" }}
                >
                    <Button
                        text="📄 Resume"
                        newTab={true}
                        // href={greeting.resumeLink}
                        theme={theme}
                        className={styles.resume_btn_div}
                    />
                </NavLink> */}
            </div>
            {/* <Footer theme={this.props.theme} onToggle={this.props.onToggle} /> */}
            <br />

            <div>
                <FormControl style={{ width: "250px" }}>
                    <InputLabel htmlFor="my-input">Name</InputLabel>
                    <Input
                        id="my-input"
                        aria-describedby="my-helper-text"
                        onChange={(e) => setName(e.target.value)}
                        value={name}
                    />
                </FormControl>
                <br />
                <FormControl style={{ width: "250px" }}>
                    <InputLabel htmlFor="my-input">Email</InputLabel>
                    <Input
                        id="my-input"
                        aria-describedby="my-helper-text"
                        onChange={(e) => setEmail(e.target.value)}
                        value={email}
                    />
                </FormControl>
                <br />
                <br />
                <TextareaAutosize
                    aria-label="minimum height"
                    minRows={3}
                    style={{ width: "250px" }}
                    placeholder="Write your message"
                    onChange={(e) => setSubject(e.target.value)}
                    value={subject}
                />
                <br />

                {/* <button
                    type="primary"
                    ghost
                    style={{
                        background: "#14213D",
                        borderRadius: "5px",
                        outline: "none",
                        border: "none",
                        fontSize: "15px",
                        color: "#DED6CA",
                        paddingTop: "1%",
                        paddingBottom: "1%",
                        paddingLeft: "3%",
                        paddingRight: "3%",
                        cursor: "pointer",
                    }}
                    onClick={() => handleSubmit({ name, email, subject })}
                >
                    SEND
                </button> */}
                <ContactButton
                    text="📤 Send"
                    newTab={true}
                    // href={greeting.resumeLink}
                    theme={theme}
                    className={styles.resume_btn_div}
                    handleSubmit={handleSubmit}
                    data={{ name, email, subject }}
                />
            </div>

            <br />
            <p className={styles.footer_text} style={{ color: "red" }}>
                Made with <span>❤️ and JavaScript</span>
            </p>
            {/* <TopButton theme={this.props.theme} /> */}
        </div>
    );
};
